import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.qs-checks-rolle-berechtigung';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksQsChecksRolleBerechtigungEffects {

    QsChecksRolleBerechtigung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_QS_CHECKS_ROLLE_BERECHTIGUNG),
        mergeMap((x: ac.GetQsChecksRolleBerechtigungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getQsChecksRolleBerechtigung(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetQsChecksRolleBerechtigungErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetQsChecksRolleBerechtigungFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenQueryService);
        }
        return this.service;
    }
}
